// src/components/TemplateWorkspace/updateWorkspace.js
import { getFunctions, httpsCallable } from 'firebase/functions';

// Initialize Firebase Functions
const functions = getFunctions();
const updateWorkspaceCallable = httpsCallable(functions, 'modifyWorkspace');

/**
 * Function to update an existing workspace via Firebase Cloud Functions
 * @param {Object} params - Parameters for workspace update
 */
const updateWorkspace = async ({
  user,
  content_id,
  workspaceTitle,
  isSCTimestampsEnabled,
  isSCDescriptionEnabled,
  isSCTakeawaysEnabled,
  isSCTitlesEnabled,
  isSCTagsEnabled,
  promptMap,
  chatNameMap,
}) => {
  const workspaceData = {
    contentId: `workspace-${content_id}`,
    createdBy: user.uid,
    workspaceTitle,
    isSCTimestampsEnabled,
    isSCDescriptionEnabled,
    isSCTakeawaysEnabled,
    isSCTitlesEnabled,
    isSCTagsEnabled,
    promptMap,
    chatNameMap,
    isTranscriptAvailable: false,
  };

  try {
    await updateWorkspaceCallable({ workspaceData });

    // Clear local storage cache for the user's workspace videos
    const localStorageKey = `videoCache_${user.uid}_WorkspaceVideos`;
    localStorage.removeItem(localStorageKey);
  } catch (error) {
    throw error;
  }
};

export { updateWorkspace };
